import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import {
  DashboardIcon,
  DataUploadIcon,
  FaciltyIcon,
  FixedDepositIcon,
  GuaranteeReportIcon,
  GuaranteeSummaryIcon,
  LoanIcon,
  LOCIcon,
  LogOutIcon,
  MasterDataIcon,
  MISPortalIcon,
  UserIcon,
} from 'app/__tests__/assets/Icons';
import { NavLink } from 'react-router-dom';
import { Spin as Hamburger } from 'hamburger-react';
import { CommonMessages } from 'locales/CommonMessage/messages';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { DiscardPopUp } from '../DiscardPopup';
import { useNavigateToRoute } from 'utils/common';
import { useMISPortalApi } from 'app/hooks/useMISPortalApi';
import { MainLoader } from '../SkeletonLoader/MainLoader';
import { useDataUploadApi } from 'app/hooks/useDataUploadApi';

const SideBar = () => {
  const { t } = useTranslation();
  const redirect = useNavigateToRoute();
  const [isBurgerMenu, setIsBurgerMenu] = useState(false);
  const [isBurgerMenuOpen, setIsBurgerMenuOpen] = useState(true);
  const [showConfirmationPopup, setShowConfirmationPopup] =
    React.useState(false);
  const [selectedUrl, setSelectedUrl] = useState<string>();
  const menuRef = useRef<HTMLDivElement>(null);
  // API HOOKS
  const { useMisPortalGetApi, isLoading } = useMISPortalApi();
  const { useGetDataUploadsData } = useDataUploadApi();
  //API Calling
  const getMISApi = useMisPortalGetApi();
  const getUploadApi = useGetDataUploadsData();
  const handleClick = (item: string) => {
    if (item === '/') {
      Cookies.remove('access_token');
      Cookies.remove('refreshToken');
      Cookies.remove('tokenExpiry');
    }
    if (window.innerWidth < 768) {
      setIsBurgerMenuOpen(false); // Close the menu after clicking an item
    }
  };

  const handleOutsideClick = (event: MouseEvent) => {
    if (
      window.innerWidth < 768 &&
      menuRef.current &&
      !menuRef.current.contains(event.target as Node)
    ) {
      setIsBurgerMenuOpen(false); // Close the menu if clicked outside
    }
  };

  const Urls = [
    {
      url: '/dashboard/facility',
      text: t(CommonMessages.dashboard()),
      icon: <DashboardIcon />,
    },
    {
      url: '/facility',
      text: t(CommonMessages.facility()),
      icon: <FaciltyIcon />,
    },
    {
      url: '/loan',
      text: t(CommonMessages.loan()),
      icon: <LoanIcon />,
    },
    {
      url: '/letter-of-credit',
      text: t(CommonMessages.loc()),
      icon: <LOCIcon />,
    },
    {
      url: '/fixed-deposit',
      text: t(CommonMessages.fixedDeposit()),
      icon: <FixedDepositIcon />,
    },
    {
      url: '/guarantee-program',
      text: 'Guarantee\nProgram',
      icon: <FixedDepositIcon />,
    },
    {
      url: '/guarantee-report',
      text: 'Guarantee\nReport',
      icon: <GuaranteeReportIcon />,
    },
    {
      url: '/guarantee-summary',
      text: 'Guarantee\nSummary',
      icon: <GuaranteeSummaryIcon />,
    },
    // Rate commenting for now may usefull for the future
    // {
    //   url: '/rate',
    //   text: t(CommonMessages.rate()),
    //   icon: <RateIcon />,
    // },
    {
      url: '/user',
      text: t(CommonMessages.user()),
      icon: <UserIcon />,
    },
    {
      url: '/master-data',
      text: t(CommonMessages.masterData()),
      icon: <MasterDataIcon />,
    },
    {
      url: '/mis-portal',
      text: t(CommonMessages.mISPortal()),
      icon: <MISPortalIcon />,
    },
    {
      url: '/data-upload',
      text: t(CommonMessages.dataUpload()),
      icon: <DataUploadIcon />,
    },
    {
      url: '/logout',
      text: t(CommonMessages.logOut()),
      icon: <LogOutIcon />,
    },
  ];
  const handleDiscardClick = () => {
    if (selectedUrl) {
      setShowConfirmationPopup(false);
      sessionStorage.removeItem('isChangesDone');
      redirect(selectedUrl);
    }
  };
  useEffect(() => {
    const handleResize = () => {
      setIsBurgerMenu(window.innerWidth < 768);
      if (window.innerWidth < 768) {
        setIsBurgerMenuOpen(false);
      } else {
        setIsBurgerMenuOpen(true);
      }
    };

    handleResize(); // Set initial value
    window.addEventListener('resize', handleResize);
    document.addEventListener('mousedown', handleOutsideClick); // Add outside click listener

    return () => {
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('mousedown', handleOutsideClick); // Cleanup listener
    };
  }, []);

  return (
    <CommonWrapper className="side-bar-burger-menu" ref={menuRef}>
      {isBurgerMenu && (
        <BurgerMenuWrapper>
          <Hamburger
            toggled={isBurgerMenuOpen}
            toggle={setIsBurgerMenuOpen}
            direction="right"
            duration={0.33}
            easing="ease-in"
          />
        </BurgerMenuWrapper>
      )}
      {isBurgerMenuOpen && (
        <Wrapper>
          {isLoading && <MainLoader />}
          <SubWrapper className="SubWrapper">
            {Urls.map((item, index) => (
              <StyledNavLink
                className="nav-page-links"
                to={item.url}
                key={index}
                onClick={e => {
                  if (item.url === '/mis-portal') {
                    e.preventDefault(); // Prevent default navigation
                    getMISApi.mutate({ mISCode: '' });
                  } else if (item.url === '/data-upload') {
                    e.preventDefault(); // Prevent default navigation
                    getUploadApi.mutate({ uploadCode: '' });
                  } else if (
                    sessionStorage.getItem('isChangesDone') === 'true' ? true : false
                  ) {
                    setSelectedUrl(item.url);
                    e.preventDefault(); // Prevent default navigation
                    setShowConfirmationPopup(true);
                  }
                  handleClick(item.url); // Your existing click handler
                }}
              >
                <IconWrapper className="icon-wrapper">
                  {item.icon}
                  <span>{item.text}</span>
                </IconWrapper>
              </StyledNavLink>
            ))}
          </SubWrapper>
        </Wrapper>
      )}
      <DiscardPopUp
        isShowPopup={showConfirmationPopup}
        setIsShowPopup={setShowConfirmationPopup}
        onDiscardClickOrDelete={handleDiscardClick}
        onCancelClick={() => setShowConfirmationPopup(false)}
        mainTitle="Discard Changes?"
      />
    </CommonWrapper>
  );
};

export default SideBar;

const Wrapper = styled.div`
  height: 100%;
  width: 92px;
  border: 1px solid ${p => p.theme.sideBarBorderColor};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 11px;
  padding-top: 15px;
  background: ${p => p.theme.white};
  z-index: 101;
  padding-bottom: 20px;
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 6px;
    height: 4px;
  }
  &::-webkit-scrollbar-track {
    background: ${p => p.theme.layoutPageScrollColor};
  }
  &::-webkit-scrollbar-thumb {
    width: 9px;
    background: ${p => p.theme.layoutPageScrollThumbColor};
  }
`;

const SubWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 11px;
  .nav-page-links {
    &:last-child {
      margin-bottom: 18px;
    }
    &.active {
      .icon-wrapper {
        border-radius: 4px;
        background: ${p => p.theme.sideBarSelectedItemBgClr};
        font-weight: 600;
        svg path {
          fill: ${p => p.theme.black} !important;
        }
      }
    }
  }
`;

const StyledNavLink = styled(NavLink)`
  text-decoration: none;
  color: unset;
`;

const IconWrapper = styled.div`
  padding-top: 9px;
  width: 74px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end;
  svg {
    width: 20px;
    height: 20px;
  }
  span {
    margin: 0 0 0 0;
    font-size: 10px;
    font-family: 'Open Sans';
    text-align: center;
    white-space: pre-line;
    color: ${p => p.theme.sideBarItemTextClr};
    @media (max-width: 768px) {
      font-size: 6.67px;
    }
    @media (min-width: 769px) and (max-width: 991px) {
      font-size: 6.88px;
    }
    @media (min-width: 992px) and (max-width: 1023px) {
      font-size: 7.1px;
    }
    @media (min-width: 1024px) and (max-width: 1279px) {
      font-size: 8.88px;
    }
    @media (min-width: 1280px) and (max-width: 1365px) {
      font-size: 9.48px;
    }
    @media (min-width: 1366px) and (max-width: 1439px) {
      font-size: 9.99px;
    }
    @media (min-width: 1440px) and (max-width: 1600px) {
      font-size: 11.11px;
    }
    @media (min-width: 1601px) and (max-width: 1799px) {
      font-size: 12.49px;
    }
  }
  //Responsive
`;

const BurgerMenuWrapper = styled.div`
  margin-left: 18px;
  .hamburger-react {
    div {
      border-radius: 2px !important;
      background-color: #101317;
    }
    div:nth-child(2) {
      width: 22px !important;
    }
  }
`;

const CommonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 80px);
`;
